import app from '../app';
import passwordMain from './password/password-main';
import passwordForm from './password/passwordForm'

app.add({
  passwordMain,
  passwordForm
});
app.mount();
